import { render, staticRenderFns } from "./faqSidebar.vue?vue&type=template&id=0b063cfd&scoped=true&"
import script from "./faqSidebar.vue?vue&type=script&lang=js&"
export * from "./faqSidebar.vue?vue&type=script&lang=js&"
import style0 from "./faqSidebar.vue?vue&type=style&index=0&id=0b063cfd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b063cfd",
  null
  
)

export default component.exports